module.exports = __webpack_public_path__ + "static/img/agreeBook-table.7c2699b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agreeBook-table.png
// module id = wfJn
// module chunks = 1